module.exports = __webpack_public_path__ + "img/title-1.c4686a89.png";